import { Box } from "@mui/material";

const NavbarSpacer = () => {
    return <Box width="auto" height="90px" minHeight="90px"></Box>;
};

export default NavbarSpacer;
